import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig';

const PublicRoute = () => {
	const { token, redirect, sessionLoaded } = useSelector((state) => state.auth);

	if (token && sessionLoaded && redirect) {
		return <Navigate to={redirect} replace />;
	}

	if (token && sessionLoaded) {
		return <Navigate to={AUTHENTICATED_ENTRY} replace />;
	}

	return <Outlet />;
};

export default PublicRoute;